import { atomWithKey as atom } from "./atomWithKey";
import { PlaceMapResponse } from "../Types/Types/Checkout/Seating/PlaceMap";
import { CoachLayoutResponse } from "../Types/Types/Checkout/Seating/CoachLayoutResponse";
import { FloorPlanIconResponse } from "../Types/Types/Checkout/Seating/FloorPlanIconResponse";

export const seatSelectorOpenAtom = atom<boolean>({
    key: "seatSelectorOpenAtom",
    default: false
})

export const selectedSeatsAtom = atom<Record<string, string>[]>({
    key: "selectedSeatsAtom",
    default: []
})

export const originalSeatsAtom = atom<{ place?: string, coach?: string }[][]>({
    key: "originalSeatsAtom", 
    default: []
})

export const confirmedSeatsAtom = atom<Record<string, string>[]>({
    key: "confirmedSeatsAtom",
    default: []
})

export const placeMapResponseAtom = atom<PlaceMapResponse[] | null>({
    key: "placeMapResponseAtom",
    default: null,
});

export const coachLayoutResponseAtom = atom<CoachLayoutResponse | null>({
    key: "coachLayoutResponseAtom",
    default: null,
});

export const floorPlanIconsResponseAtom = atom<FloorPlanIconResponse | null>({
    key: "floorPlanIconsResponseAtom",
    default: null,
});

export const seatServiceClassAtom = atom<string[]>({
    key: "seatServiceClassAtom",
    default: [],
});


export const seatTravelClassAtom = atom<string[]>({
    key: "seatTravelClassAtom",
    default: [],
});

export const selectedCoachAtom = atom<string>({
    key: "selectedCoachAtom",
    default: "",
});

export const unavailableSeatsAtom = atom<string[]>({
    key: "unavailableSeatsAtom",
    default: [],
});

export const isManageSeatingAtom = atom<boolean>({
    key: "isManageSeatingAtom",
    default: false,
});

export const seatsChangedOnCheckoutAtom = atom<boolean>({
    key: "seatsChangedOnCheckoutAtom",
    default: false,
});

// Snapshot of seats that were available when the seat selector first opened (keyed as "coach-place").
// Persists across modal close/reopen so the hint icon survives for the session.
export const initiallyAvailableSeatsAtom = atom<string[] | null>({
    key: "initiallyAvailableSeatsAtom",
    default: null,
});
